import ChangeLogIcon from './component'

export default ChangeLogIcon
